/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Transfert list item
 */

// required attributes
const TransferListItemR = t.interface({});

// optional attributes
const TransferListItemO = t.partial({
  creditorInstitution: t.string,

  digitalStamp: t.boolean,

  transferCategory: t.string
});

export const TransferListItem = t.intersection(
  [TransferListItemR, TransferListItemO],
  "TransferListItem"
);

export type TransferListItem = t.TypeOf<typeof TransferListItem>;
